module.exports = __webpack_public_path__ + "static/media/calendar-icon.2ca66ed3.svg";